var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2578 34.2168H14.2578C6.11281 34.2168 2.63281 30.7368 2.63281 22.5918V13.5918C2.63281 5.4468 6.11281 1.9668 14.2578 1.9668H23.2578C31.4028 1.9668 34.8828 5.4468 34.8828 13.5918V22.5918C34.8828 30.7368 31.4028 34.2168 23.2578 34.2168ZM14.2578 4.2168C7.34281 4.2168 4.88281 6.6768 4.88281 13.5918V22.5918C4.88281 29.5068 7.34281 31.9668 14.2578 31.9668H23.2578C30.1728 31.9668 32.6328 29.5068 32.6328 22.5918V13.5918C32.6328 6.6768 30.1728 4.2168 23.2578 4.2168H14.2578Z",
    fill: "#273239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3828 14.7168H13.1328C12.5178 14.7168 12.0078 14.2068 12.0078 13.5918C12.0078 12.9768 12.5178 12.4668 13.1328 12.4668H24.3828C24.9978 12.4668 25.5078 12.9768 25.5078 13.5918C25.5078 14.2068 24.9978 14.7168 24.3828 14.7168Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3828 23.7168H13.1328C12.5178 23.7168 12.0078 23.2068 12.0078 22.5918C12.0078 21.9768 12.5178 21.4668 13.1328 21.4668H24.3828C24.9978 21.4668 25.5078 21.9768 25.5078 22.5918C25.5078 23.2068 24.9978 23.7168 24.3828 23.7168Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a10870572cec1613cdf911471e54db86.svg";
export { ForwardRef as ReactComponent };